<template>
  <nav class="navbar py-0 navbar-light justify-content-between flex-nowrap flex-row fixed-top">
    <div class="container">
      <router-link :to="{ name: 'top', params: {} }" class="navbar-brand">
        <img src="~assets/photo_spot_international_header_logo.png" class="img-fluid">
      </router-link>
      <header-right-menu-p-c @logout="logout" iconSizeClass="fa-4x" headerHeight="70" iconWidth="85" />
    </div>
  </nav>
</template>
<script>
  import {dd,store,app} from 'systems/imports'
  import HeaderRightMenuPC from 'components/global/partials/HeaderRightMenuPC.vue'

  export default {
    name:"",
    components: {
      HeaderRightMenuPC,
    },
    data () {
      return {
      }
    },
    mounted(){
      this.$nextTick(()=>{
        app.make("adjustLayout")()
      })
    },
    methods:{
      logout(){
        this.$emit('logout')
      }
    }
  }
</script>


<style lang="scss" scoped>
  .navbar {
    background-size: 10% auto;
    background: url("~assets/header_orange_bg.png");
    background-repeat: repeat;
    border-bottom: 3px #ea502e solid;

    .navbar-brand {
      max-width: 400px;
      position: absolute;
      left: 0;
      bottom: 10%;
    }
  }
</style>



// WEBPACK FOOTER //
// PCHeader.vue?663fd8f0